// The one call that writes a manual kit mark.
//
// It exists as a helper because the manual mode has two surfaces — the prompt
// in the logistics table toolbar and the per-panel action in the left-menu tree
// — and both have to split the selection by level. The two routes are scoped to
// their own model, so a module posted to the assemblies route is dropped
// without a word.

import { backend_api_v2 } from "/src/utils/apiv2";
import bus from "/src/utils/event_bus";
import { useConstructiblesStore } from "@/stores/constructibles";

/**
 * Set or clear the kit override on a list of constructible uuids.
 *
 * @param {string[]} uuids  constructibles, assemblies and modules mixed
 * @param {boolean}  kitted true to mark, false to clear
 * @param {Function} t      the translator, for the toast
 */
export async function markKits(uuids, kitted, t) {
    const store = useConstructiblesStore();
    const module_uuids = new Set(store.modules.map(m => m.uuid));

    const groups = { assemblies: [], modules: [] };
    (uuids || []).forEach(uuid => {
        groups[module_uuids.has(uuid) ? "modules" : "assemblies"].push(uuid);
    });

    try {
        await Promise.all(Object.entries(groups)
            .filter(([, list]) => list.length)
            .map(([route, list]) => backend_api_v2
                .post(`/constructibles/${route}/mark_kitted/`, { uuids: list, kitted })
                .then(({ data }) => {
                    (data?.results || data || []).forEach(actual => route === "modules"
                        ? store.updateModule(actual)
                        : store.updateAssembly(actual));
                })));
        if (t) bus.emit("notification", { text: t("kit_marked_ok"), color: "success" });
        return true;
    } catch (error) {
        console.error("Could not mark the kit", error);
        if (t) bus.emit("notification", { text: t("kit_mark_failed"), color: "error" });
        return false;
    }
}
